import * as React from 'react';
import type { MetadataResponse } from '~/services/api.server';

export function useInitStorageInfo(metadata?: MetadataResponse['results']) {
  React.useEffect(() => {
    if (metadata) {
      initStorageInfo(metadata);
    }
  }, [metadata]);
}

async function initStorageInfo(metadata: MetadataResponse['results']) {
  
  try {
    localStorage.setItem('storage-prices-state', 'loading');
    const storagePriceVersion = metadata.find((m) => m.key === 'STORAGE_PRICE_VERSION')?.value ?? '0';
    const currentStoragePriceVersion = localStorage.getItem('storage-prices-version');

    if (storagePriceVersion !== currentStoragePriceVersion) {
      const result = await fetch('/api/storage-prices?version=' + storagePriceVersion).then((res) => res.json());
      localStorage.setItem('storage-prices', JSON.stringify(result));
      localStorage.setItem('storage-prices-version', storagePriceVersion);
    }

    localStorage.setItem('storage-prices-state', 'idle');
  } catch (error) {
    localStorage.setItem('storage-prices-state', 'error');
  }
}
